module.exports = __webpack_public_path__ + "static/assets/4547b9c1c2529ca15b22efa51188629e.svg";